import { render, staticRenderFns } from "./outordersummary.vue?vue&type=template&id=45ba7a4a&scoped=true&"
import script from "./outordersummary.vue?vue&type=script&lang=js&"
export * from "./outordersummary.vue?vue&type=script&lang=js&"
import style0 from "./outordersummary.vue?vue&type=style&index=0&id=45ba7a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba7a4a",
  null
  
)

export default component.exports